<template>
	<div>
		<div class="box_all">
			<div class="box_content_one">
				<div class="title_font">{{$t('label_1054')}}</div>
				<div class="tableMin">
					<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime1" highlight-current-row border height="460" style="width: 90%;margin:10px 0 10px 0;"
					 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
						<el-table-column header-align="center" align="center" label="No" type="index" width="50">
						</el-table-column>
						<el-table-column prop="faultReason" :label="$t('label_389')" align="center" width="200">
						</el-table-column>
						<el-table-column prop="repairNum" :label="$t('label_1051')" align="center">
						</el-table-column>
						<el-table-column prop="repairTime" :label="$t('label_1052')" align="center" width="120">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="box_content_two">
				<div class="title_font">{{$t('label_1053')}}</div>
				<div class="tableMin">
					<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row border height="460" style="width: 90%;margin:10px 0 10px 0;"
					 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
						<el-table-column header-align="center" align="center" label="No" type="index" width="50">
						</el-table-column>
						<el-table-column prop="faultReason" :label="$t('label_389')" align="center" width="200">
						</el-table-column>
						<el-table-column prop="repairNum" :label="$t('label_1051')" align="center">
						</el-table-column>
						<el-table-column prop="repairTime" :label="$t('label_1052')" align="center" width="120">
						</el-table-column>
					</el-table>
					<div style="position: absolute;bottom: 0;left: 30%">
						<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
						 @parentMethod="searchPage"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import common from "@/assets/js/common/common.js";
	import statistics from "@/assets/js/statistics/statistics.js";
	import exportMes from "@/components/list/export/export";
	export default {
		name: "GztabularStatistics",
		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo,
			exportMes,
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				tableDataTreeTime: [],
				tableDataTreeTime1: [],
				Readytime: '',
				searchData: {},
			}
		},
		methods: {
			newMes(param) {
				this.searchData = param
				this.search();
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
				// this.initDate();
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},

			searchPage(param) {
				var dataParam = {
					id: this.searchData.id,
					type: this.searchData.type,
					beginTime: this.searchData.beginTime,
					endTime: this.searchData.endTime,
					name: this.searchData.name,
				};
				var newParam = Object.assign(param, dataParam);
				statistics.repair2(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records[0].List1;
						this.tableDataTreeTime1 = data.data.records[0].List2;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;


					}
				}).catch((response) => {
					console.log(response)
				})
			},
		},
		mounted() {

		}
	}
</script>

<style scoped>
	.background1 .treeMes .el-tabs__content {
		height: 100%;
	}

	.box_all {
		width: 100%;
		display: flex;
	}

	.box_content_one {
		width: 50%;
	}

	.box_content_two {
		width: 50%;
	}

	.title_font {
		font-size: 20px;
		color: #3FB393;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/tabPane/GztabularStatistics.vue